// extracted by mini-css-extract-plugin
export default {"sbomSummary":"M56d0BOO_V_1eOtRfw__"};